/* ************************* */
//
// Dreamcoat Login - Two-step authentication flow
// This file will be made available as /assets/dreamcoat/login.js by webpack
//
/* ************************* */

const { paths, urls } = require("@root/sugarconfig");
const {
    getParamsFromQuery,
    postAsyncJSON,
} = require("@sugarfrontend/modules/shared");
const { stringify } = require("querystring");
const { asyncFormSubmit } = require("@sugarfrontend/forms");
const { modalLoadUrl } = require("@sugarfrontend/modules/modals");
const {
    initLocalForage,
    togglePasswordVisibility: togglePassword,
    isValidEmail,
    updateButtonState,
    showAlertBox,
    hideAlertBox,
    recaptchaV3Ping,
} = require("./utils");

// DOM Elements
let emailInputEl = null,
    passwordInputEl = null,
    loginForm = null,
    continueBtn = null,
    continueLabelEl = null,
    loginBtn = null,
    loginLabelEl = null,
    backBtn = null,
    togglePasswordBtn = null,
    stepEmail = null,
    stepPassword = null,
    displayEmailEl = null,
    loginTroubleEl = null;

const windowOptions = window.options;
const isModal = windowOptions && windowOptions.modal === "true";

$(document).ready(function () {
    // Clear localforage
    initLocalForage();
    recaptchaV3Ping("login_view");

    // Initialize DOM elements
    loginForm = $("#dc-login-form");
    emailInputEl = $("#inputEmail", loginForm);
    passwordInputEl = $("#inputPassword", loginForm);
    continueBtn = $("#continue-button", loginForm);
    continueLabelEl = $("#continue-label-span", loginForm);
    loginBtn = $("#login-button", loginForm);
    loginLabelEl = $("#login-label-span", loginForm);
    backBtn = $("#back-button", loginForm);
    togglePasswordBtn = $("#toggle-password", loginForm);
    stepEmail = $("#step-email", loginForm);
    stepPassword = $("#step-password", loginForm);
    displayEmailEl = $("#display-email", loginForm);
    loginTroubleEl = $("#login-trouble-link", loginForm);

    // Event Listeners
    emailInputEl.on("keyup", emailInputChanged);
    emailInputEl.on("keypress", function (e) {
        if (e.which === 13) {
            e.preventDefault();
            continueBtn.click();
        }
    });

    passwordInputEl.on("keyup", passwordInputChanged);

    continueBtn.on("click", handleContinue);
    backBtn.on("click", handleBack);
    togglePasswordBtn.on("click", function () {
        togglePassword(passwordInputEl, togglePasswordBtn);
    });

    loginTroubleEl.on("click", function (e) {
        e.preventDefault();
        let url = $(this).attr("href");
        if (emailInputEl.val().length > 3) {
            url += "?email=" + encodeURIComponent(emailInputEl.val());
        }
        window.location.href = url;
    });

    loginForm.on("submit", function (e) {
        e.preventDefault();

        // Required validation for password
        const password = passwordInputEl.val();
        if (!password) {
            showMessage("Password is required.", "danger", "step2");
            return;
        }

        // Minimum length validation (kept at 4 for backward compatibility with existing users)
        if (password.length < 4) {
            showMessage(
                "Password must be at least 4 characters.",
                "danger",
                "step2"
            );
            return;
        }

        if (!canAttemptLogin()) return;
        updateLoginButtonView("working");
        asyncFormSubmit($(this), loginFormSuccess, loginFormError);
    });

    // Signup link handling
    if (isModal) {
        $(".signup-link a", loginForm).on("click", function (e) {
            e.preventDefault();
            const queryParams = "?" + stringify(windowOptions);
            modalLoadUrl($(this).attr("href") + queryParams, "md");
        });
    } else {
        $(".signup-link a", loginForm).attr(
            "href",
            "/signup" + window.location.search
        );
    }

    // Check for email in query params (supports both 'username' and 'email' params)
    const params = getParamsFromQuery(document.location.search);
    const emailParam = params.username || params.email;

    if (emailParam) {
        const email = decodeURIComponent(emailParam);
        emailInputEl.val(email);

        // Check if coming from password reset or verification
        const showPasswordResetAlert = params["password-reset"] === "true";
        const showVerificationAlert = params["isVerified"] === "true";
        if (showVerificationAlert || showVerificationAlert) {
            $("#step-password .title").hide();
        }
        showPasswordStep(email, showPasswordResetAlert, showVerificationAlert);
    }

    // Initial state
    emailInputChanged();
});

// Handle Continue button click (Step 1 -> Step 2)
function handleContinue() {
    const email = emailInputEl.val().trim().toLowerCase();

    // Required validation
    if (!email) {
        showMessage("Email address is required.", "danger");
        return;
    }

    // Email format validation
    if (!isValidEmail(email)) {
        showMessage("Please enter a valid email address.", "danger");
        return;
    }

    updateContinueButtonView("working");

    // Check if email exists in database
    postAsyncJSON(
        paths.public_api_prefix + "/check-email",
        { email: email },
        "",
        function (response) {
            if (response.success) {
                if (!response.exists) {
                    // User not found, redirect to signup with email input box
                    window.location.href = response.redirectUrl;
                } else if (response.isUnverified) {
                    // User exists but unverified, redirect to signup without email input box
                    window.location.href = response.redirectUrl;
                } else {
                    // User exists and is verified, show password step
                    showPasswordStep(email);
                }
            } else {
                showMessage(
                    response.message || "An error occurred. Please try again.",
                    "danger"
                );
                updateContinueButtonView("ready");
            }
        },
        function (error) {
            const message =
                error.message || "An error occurred. Please try again.";
            showMessage(message, "danger");
            updateContinueButtonView("ready");
        }
    );
}

// Show password step
function showPasswordStep(
    email,
    showPasswordResetSuccess,
    showVerificationSuccess
) {
    hideAlertBox();
    displayEmailEl.text(email);
    stepEmail.removeClass("active");
    stepPassword.addClass("active");
    passwordInputEl.focus();
    updateContinueButtonView("ready");
    passwordInputChanged();

    // Show password reset success alert if coming from password reset (takes priority)
    if (showPasswordResetSuccess) {
        showAlertBox(
            "alert-container",
            "success",
            "Your password has been updated. Please log in with your new password."
        );
        backBtn.hide();
        stepPassword.find(".title").hide();
    } else if (showVerificationSuccess) {
        // Show verification success alert if coming from OTP verification
        showAlertBox(
            "alert-container",
            "success",
            "Your account has been verified. Please log in to access your account."
        );
        backBtn.hide();
        stepPassword.find(".title").hide();
    }
}

// Handle Back button click (Step 2 -> Step 1)
function handleBack() {
    hideAlertBox();
    stepPassword.removeClass("active");
    stepEmail.addClass("active");
    emailInputEl.focus();
    passwordInputEl.val("");
}

// Input change handlers
function emailInputChanged() {
    const email = emailInputEl.val().trim();
    continueBtn.prop("disabled", email.length < 5 || !isValidEmail(email));
}

function passwordInputChanged() {
    loginBtn.prop("disabled", !canAttemptLogin());
}

function canAttemptLogin() {
    return emailInputEl.val().length > 4 && passwordInputEl.val().length >= 4;
}

// Button view updates
function updateContinueButtonView(state) {
    updateButtonState(continueBtn, continueLabelEl, state, emailInputChanged);
}

function updateLoginButtonView(state) {
    updateButtonState(loginBtn, loginLabelEl, state, function () {
        loginBtn.prop("disabled", !canAttemptLogin());
    });
}

// Login success handler
function loginFormSuccess() {
    updateLoginButtonView("success");

    const params = isModal
        ? windowOptions
        : getParamsFromQuery(document.location.search);
    let url = params.url ? decodeURIComponent(params.url) : paths.home;

    delete params.url;
    delete params.modal;

    if (Object.keys(params).length) {
        url += "?" + stringify(params);
    }

    // 1. Define allowed domain patterns for the DESTINATION url
    const validDomainPatterns = [
        /^https?:\/\/\w+\.sugarwod\.com(\/|$)/,
        /^https?:\/\/localhost\:/,
        /^https?:\/\/127\.0\.0\.1:/,
        /^https?:\/\/.*\.herokuapp\.com(\/|$)/,
        /^https:\/\/sugarwod-mr-\d+\.services\.sugarwod\.com(\/|$)/,
        /^https:\/\/sugarwod-staging\.services\.sugarwod\.com(\/|$)/,
    ];

    // 2. Check if it's a relative path (starts with / but not //) or matches allowed domains
    const isRelativePath = /^\/[^\/]+/.test(url) || url === "/";
    const isValidRedirectDomain = validDomainPatterns.some((pattern) =>
        pattern.test(url)
    );

    // 3. Safely redirect
    if (isRelativePath || isValidRedirectDomain) {
        window.location.href = url;
    } else {
        window.location.href = paths.home;
    }
}

// Login error handler
function loginFormError(result) {
    showMessage("Invalid email address or password", "danger", "step2");
    //showMessage(result.message, "danger", "step2");
    updateLoginButtonView("ready");
}

// Message display
function showMessage(msg, type, step) {
    hideAlertBox();
    if (step === "step2") {
        // Show error in alert box for step 2
        showAlertBox("alert-container", "error", msg);
    } else {
        // Show error inline for step 1 (appends after input's parent)
        showAlertBox(emailInputEl, "error", msg, "inline");
    }
}
